/*
 * Copyright (c) 2022 Reservo LLC. All rights reserved.
 */


function reservo_init_form_masks(){
	if(('intlTelInput' in window) && ('intlTelInputGlobals' in window)) {
		jQuery('.os-mask-phone').each(function() {
			reservo_mask_phone(jQuery(this));
		});
	}
}

function reservo_init_payment_method_actions($booking_form_element, payment_method){
    var callbacks_list = [];
    var is_last_step = $booking_form_element.data('next-submit-is-last') == 'yes';
    $booking_form_element.trigger('reservo:initPaymentMethod', [{ payment_method: payment_method,
                                                                    callbacks_list: callbacks_list,
                                                                    is_last_step: is_last_step }]);
    $booking_form_element.removeClass('step-content-loaded').addClass('step-content-loading');
    jQuery.when(...callbacks_list.map(callback => callback.action()))
      .done(() => {
        $booking_form_element.removeClass('step-content-loading').addClass('step-content-loaded').find('.lp-payment-method-content[data-payment-method="' + payment_method + '"]').show();
      })
      .fail((err) => { console.error(err)});
  }

  function reservo_lightbox_close(){
    jQuery('body').removeClass('reservo-lightbox-active');
    jQuery('.reservo-lightbox-w').remove();
  }

  function reservo_show_next_btn($booking_form_element){
    $booking_form_element.find('.reservo-next-btn').removeClass('disabled');
    $booking_form_element.removeClass('hidden-buttons');
  }

  function clear_step_services($booking_form_element){
    reservo_reload_summary($booking_form_element, 'service', '');
    clear_sub_step_attendies($booking_form_element);
  }

  function clear_sub_step_attendies($booking_form_element){
    $booking_form_element.find('.reservo_total_attendies').val(1);
    reservo_reload_summary($booking_form_element, 'total-attendies', '');
    clear_sub_step_duration($booking_form_element);
  }

  function clear_sub_step_duration($booking_form_element){
    $booking_form_element.find('.reservo_duration').val('');
    reservo_reload_summary($booking_form_element, 'duration', '');
  }

  function clear_step_service_extras($booking_form_element){
    reservo_reload_summary($booking_form_element, 'service-extras', '');
  }

  function clear_step_locations($booking_form_element){
    reservo_reload_summary($booking_form_element, 'location', '');
  }

  function clear_step_agents($booking_form_element){
    reservo_reload_summary($booking_form_element, 'agent', '');
  }

  function clear_step_datepicker($booking_form_element){
    reservo_reload_summary($booking_form_element, 'time', '');
    reservo_reload_summary($booking_form_element, 'date', '');
  }

  function reservo_hide_next_btn($booking_form_element){
    $booking_form_element.find('.reservo-next-btn').addClass('disabled');
    if($booking_form_element.find('.reservo-prev-btn.disabled').length) $booking_form_element.addClass('hidden-buttons');
  }


  function reservo_show_prev_btn($booking_form_element){
    $booking_form_element.find('.reservo-prev-btn').removeClass('disabled');
    $booking_form_element.removeClass('hidden-buttons');
  }

  function reservo_hide_prev_btn($booking_form_element){
    $booking_form_element.find('.reservo-prev-btn').addClass('disabled');
    if($booking_form_element.find('.reservo-next-btn.disabled').length) $booking_form_element.addClass('hidden-buttons');
  }


function reservo_show_capacity_selector($item){
  var $booking_form_element = $item.closest('.reservo-booking-form-element');
  var max_capacity = $item.data('max-capacity');
  var min_capacity = $item.data('min-capacity');
  $booking_form_element.find('.sta-sub-label span').text(max_capacity);
  $booking_form_element.find('.step-services-w').removeClass('selecting-service-duration');
  $booking_form_element.find('.total-attendies-selector-w').data('max-capacity', max_capacity);
  $booking_form_element.find('.total-attendies-selector-w').data('min-capacity', min_capacity);
  $item.closest('.step-services-w').addClass('selecting-total-attendies');
  var current_value = $booking_form_element.find('.total-attendies-selector-input').val();
  $booking_form_element.find('.total-attendies-selector-input').val(Math.max(Number(min_capacity), Number(current_value)));
  reservo_show_prev_btn($booking_form_element);
  reservo_show_next_btn($booking_form_element);
}


function reservo_show_durations($item){
  var $booking_form_element = $item.closest('.reservo-booking-form-element');
  $item.closest('.step-services-w').addClass('selecting-service-duration');
  reservo_show_prev_btn($booking_form_element);
  reservo_hide_next_btn($booking_form_element);
}

function reservo_apply_coupon($elem){
  var $booking_form_element = $elem.closest('.reservo-booking-form-element');

  var $coupon_input = $elem;
  $coupon_input.closest('.coupon-code-input-w').addClass('os-loading');
  var form_params = $booking_form_element.find('.reservo-form').serialize();
  var data = { action: reservo_helper.route_action, route_name: $elem.data('route'), params: form_params, layout: 'none', return_format: 'json' }
  jQuery.ajax({
    type : "post",
    dataType : "json",
    url : reservo_helper.ajaxurl,
    data : data,
    success: function(data){
      $coupon_input.closest('.coupon-code-input-w').removeClass('os-loading');
      if(data.status === "success"){
        $booking_form_element.find('input[name="booking[coupon_code]"]').val($coupon_input.val());
        reservo_show_message_inside_element(data.message, $booking_form_element.find('.reservo-body'), 'success');
        $booking_form_element.find('.step-payment-w input[name="booking[payment_method]"]').val('');
        $booking_form_element.find('input[name="booking[payment_token]"]').val('');
        $booking_form_element.find('input[name="booking[payment_portion]"]').val('');
        reservo_reload_step($booking_form_element);
      }else{
        reservo_show_message_inside_element(data.message, $booking_form_element.find('.reservo-body'), 'error');
      }
    }
  });
}

function reservo_remove_coupon($elem){
  $elem.closest('.applied-coupon-code').fadeOut();
  var $booking_form_element = $elem.closest('.reservo-booking-form-element');
  $booking_form_element.find('input[name="booking[coupon_code]"]').val('');
  reservo_reload_step($booking_form_element);
}

function reservo_reload_step($booking_form_element, step_name = false){

  if(step_name){
    $booking_form_element.find('.reservo_current_step').val(step_name);
    $booking_form_element.removeClass(function (index, className) { return (className.match (/(^|\s)current-step-\S+/g) || []).join(' '); }).addClass('current-step-' + step_name);
    if($booking_form_element.find('.reservo-step-content[data-step-name="'+ step_name +'"]')){
      $booking_form_element.find('.reservo-step-content[data-step-name="'+ step_name +'"]').nextAll('.reservo-step-content').remove();
      $booking_form_element.find('.reservo-step-content[data-step-name="'+ step_name +'"]').remove();
    }
  }

  $booking_form_element.find('.reservo_step_direction').val('specific');
  $booking_form_element.find('.reservo-form').submit();

  return false;
}

function reservo_get_payment_sub_step($booking_form_element, current_sub_step, prev = false){
  var offset = prev ? -1 : 1;
  var payment_sub_steps = [];
  if($booking_form_element.find('.step-payment-w .lp-payment-times-w').length) payment_sub_steps.push('payment-times');
  if($booking_form_element.find('.step-payment-w .lp-payment-methods-w').length) payment_sub_steps.push('payment-methods');
  if($booking_form_element.find('.step-payment-w .lp-payment-portions-w').length) payment_sub_steps.push('payment-portions');

  var selected_payment_method = $booking_form_element.find('input[name="booking[payment_method]"]').val();
  if(selected_payment_method) payment_sub_steps.push('payment-method-content');

  var index = payment_sub_steps.indexOf(current_sub_step) + offset;
  if(index >= 0 && index < payment_sub_steps.length){
    var sub_step = payment_sub_steps[index];
    if(sub_step == 'payment-method-content'){
      reservo_init_payment_method_actions($booking_form_element, selected_payment_method);
      // if no content exists for payment method - do not change sub step
      if(!$booking_form_element.find('.lp-payment-method-content[data-payment-method="' + selected_payment_method + '"]').length) sub_step = current_sub_step;
    }
    return sub_step;
  }else{
    return current_sub_step;
  }
}


function reservo_reset_password_from_booking_init(){
  jQuery('.os-step-existing-customer-login-w').hide();
  jQuery('.os-password-reset-form-holder').on('click', '.password-reset-back-to-login', function(){
    jQuery('.os-password-reset-form-holder').html('');
    jQuery('.os-step-existing-customer-login-w').show();
    return false;
  });
}

function reservo_reload_summary($booking_form_element, field_name = '', value = ''){
  var $summary_holder = $booking_form_element.closest('.reservo-with-summary');
  if(!$summary_holder.length) return;

  $booking_form_element.find('.reservo-summary-w').addClass('os-loading');
  var $booking_form = $booking_form_element.find('.reservo-form');
  var form_data = $booking_form.serialize();
  var data = { action: reservo_helper.route_action, route_name: reservo_helper.reload_booking_summary_route, params: form_data, layout: 'none', return_format: 'json'}
  jQuery.ajax({
    type : "post",
    dataType : "json",
    url : reservo_helper.ajaxurl,
    data : data,
    success: function(data){
      if(data.status === "success"){
        $booking_form_element.find('.os-summary-contents').html(data.message);
        $booking_form_element.find('.reservo-summary-w').removeClass('os-loading');
        $summary_holder.addClass('reservo-summary-is-open');
      }
    }
  });
  return;
}

function reservo_password_changed_show_login(response){
  jQuery('.os-step-existing-customer-login-w').show();
  jQuery('.os-password-reset-form-holder').html('');
  reservo_show_message_inside_element(response.message, jQuery('.os-step-existing-customer-login-w'), 'success');
}

function reservo_hide_message_inside_element($elem = jQuery('.reservo-body')){
  if($elem.length && $elem.find('.reservo-message').length){
    $elem.find('.reservo-message').remove();
  }
}

function reservo_show_message_inside_element(message, $elem = jQuery('.reservo-body'), message_type = 'error'){
  if($elem.length){
    if($elem.find('.reservo-message').length){
      $elem.find('.reservo-message').removeClass('reservo-message-success').removeClass('reservo-message-error').addClass('reservo-message-'+ message_type +'').html(message).show();
    }else{
      $elem.prepend('<div class="reservo-message reservo-message-'+ message_type +'">' + message + '</div>');
    }
  }
}

function reservo_add_action(callbacks_list, action, priority = 10){
  callbacks_list.push({priority: priority, action: action});
  callbacks_list.sort((a,b) => a.priority - b.priority);
  return callbacks_list;
}


function reservo_init_step(step_name, $booking_form_element){
  reservo_init_step_selectable_items();
  reservo_init_step_category_items(step_name);
  switch(step_name){
    case 'datepicker':
      reservo_init_step_datepicker();
    break;
    case 'contact':
      reservo_init_step_contact();
    break;
    case 'agents':
      reservo_init_step_agents();
    break;
    case 'locations':
      reservo_init_step_locations();
    break;
    case 'services':
      reservo_init_step_services();
    break;
    case 'payment':
      reservo_init_step_payment($booking_form_element);
    break;
    case 'verify':
      reservo_init_step_verify($booking_form_element);
    break;
    case 'confirmation':
      reservo_init_step_confirmation();
    break;
  }

  $booking_form_element.trigger("reservo:initStep", [{step_name: step_name}]);
  $booking_form_element.trigger("reservo:initStep:" + step_name);
}



function day_timeslots($day){
  var $booking_form_element = $day.closest('.reservo-booking-form-element');
  $day.addClass('selected');

  var service_duration = $day.data('service-duration');
  var interval = $day.data('interval');
  var work_start_minutes = $day.data('work-start-time');
  var work_end_minutes = $day.data('work-end-time');
  var total_work_minutes = $day.data('total-work-minutes');
  var bookable_minutes = [];
  var available_capacities_of_bookable_minute = [];
  if($day.attr('data-bookable-minutes')){
    if($day.data('bookable-minutes').toString().indexOf(':') > -1){
      // has capacity information embedded into bookable minutes string
      let bookable_minutes_with_capacity = $day.data('bookable-minutes').toString().split(',');
      for(let i = 0; i < bookable_minutes_with_capacity.length; i++){
        bookable_minutes.push(parseInt(bookable_minutes_with_capacity[i].split(':')[0]));
        available_capacities_of_bookable_minute.push(parseInt(bookable_minutes_with_capacity[i].split(':')[1]));
      }
    }else{
      bookable_minutes = $day.data('bookable-minutes').toString().split(',').map(Number);
    }
  }
  var work_minutes = $day.data('work-minutes').toString().split(',').map(Number);

  var $timeslots = $booking_form_element.find('.timeslots');
  $timeslots.html('');

  if(total_work_minutes > 0 && bookable_minutes.length && work_minutes.length){
    var prev_minutes = false;
    work_minutes.forEach(function(current_minutes){
      var ampm = reservo_am_or_pm(current_minutes);

      var timeslot_class = 'dp-timepicker-trigger';
      var timeslot_available_capacity = 0;
      if(reservo_helper.time_pick_style == 'timeline'){
        timeslot_class+= ' dp-timeslot';
      }else{
        timeslot_class+= ' dp-timebox';
      }

      if(prev_minutes !== false && ((current_minutes - prev_minutes) > service_duration)){
        // show interval that is off between two work periods
        var off_label = reservo_minutes_to_hours_and_minutes(prev_minutes + service_duration)+' '+ reservo_am_or_pm(prev_minutes + service_duration) + ' - ' + reservo_minutes_to_hours_and_minutes(current_minutes)+' '+reservo_am_or_pm(current_minutes);
        var off_width = (((current_minutes - prev_minutes - service_duration) / total_work_minutes) * 100);
        $timeslots.append('<div class="'+ timeslot_class +' is-off" style="max-width:'+ off_width +'%; width:'+ off_width +'%"><span class="dp-label">' + off_label + '</span></div>');
      }

      if(!bookable_minutes.includes(current_minutes)){
        timeslot_class+= ' is-booked';
      }else{
        if(available_capacities_of_bookable_minute.length) timeslot_available_capacity = available_capacities_of_bookable_minute[bookable_minutes.indexOf(current_minutes)];
      }
      var tick_html = '';
      var capacity_label = '';
      var capacity_label_html = '';
      var capacity_internal_label_html = '';

      if(((current_minutes % 60) == 0) || (interval >= 60)){
        timeslot_class+= ' with-tick';
        tick_html = '<span class="dp-tick"><strong>'+reservo_minutes_to_hours_preferably(current_minutes)+'</strong>'+' '+ampm+'</span>';
      }
      var timeslot_label = reservo_minutes_to_hours_and_minutes(current_minutes)+' '+ampm;
      if(reservo_show_booking_end_time()){
        var end_minutes = current_minutes + service_duration;
        if(end_minutes > 1440) end_minutes = end_minutes - 1440;
        var end_minutes_ampm = reservo_am_or_pm(end_minutes);
        timeslot_label+= ' - <span class="dp-label-end-time">' + reservo_minutes_to_hours_and_minutes(end_minutes)+' '+end_minutes_ampm + '</span>';
      }
      if(timeslot_available_capacity){
        var spaces_message = timeslot_available_capacity > 1 ? reservo_helper.many_spaces_message : reservo_helper.single_space_message;
        capacity_label = timeslot_available_capacity + ' ' + spaces_message;
        capacity_label_html = '<span class="dp-capacity">' + capacity_label + '</span>';
        capacity_internal_label_html = '<span class="dp-label-capacity">' + capacity_label + '</span>';
      }
      timeslot_label = timeslot_label.trim();
      $timeslots.removeClass('slots-not-available').append('<div class="'+timeslot_class+'" data-minutes="' + current_minutes + '"><span class="dp-label">' + capacity_internal_label_html + '<span class="dp-label-time">' + timeslot_label + '</span>' +'</span>'+tick_html+ capacity_label_html + '</div>');
      prev_minutes = current_minutes;
    });
  }else{
    // No working hours this day
    $timeslots.addClass('slots-not-available').append('<div class="not-working-message">' + reservo_helper.msg_not_available + "</div>");
  }
  jQuery('.times-header-label span').text($day.data('nice-date'));
  $booking_form_element.find('.time-selector-w').slideDown(200, function(){
    var $scrollable_wrapper = $booking_form_element.find('.reservo-body');
    $scrollable_wrapper.stop().animate({
      scrollTop: $scrollable_wrapper[0].scrollHeight
    }, 200);
  });
}




function reservo_init_timeslots(){
  jQuery('.dp-timepicker-trigger').on('click', function(){
    var $booking_form_element = jQuery(this).closest('.reservo-booking-form-element');
    if(jQuery(this).hasClass('is-booked') || jQuery(this).hasClass('is-off')){
      // Show error message that you cant select a booked period
    }else{
      if(jQuery(this).hasClass('selected')){
        jQuery(this).removeClass('selected');
        jQuery(this).find('.dp-success-label').remove();
        $booking_form_element.find('.reservo_start_time').val('');
        reservo_hide_next_btn($booking_form_element);
        reservo_reload_summary($booking_form_element, 'time', '');
      }else{
        $booking_form_element.find('.dp-timepicker-trigger.selected').removeClass('selected').find('.dp-success-label').remove();
        var selected_timeslot_time = jQuery(this).find('.dp-label-time').html();
        jQuery(this).addClass('selected').find('.dp-label').prepend('<span class="dp-success-label">' + $booking_form_element.find('.reservo-form').data('selected-label') + '</span>');

        var minutes = parseInt(jQuery(this).data('minutes'));
        var timeshift_minutes = parseInt($booking_form_element.find('.reservo_timeshift_minutes').val());
        // we substract timeshift minutes because its timeshift minutes that the business is running in, in opposite of what we do when we generate a calendar for a client
        if(timeshift_minutes) minutes = minutes - timeshift_minutes;
        var start_date = new Date($booking_form_element.find('.os-day.selected').data('date'));
        if(minutes < 0){
          // business minutes are in previous day
          minutes = 24*60 + minutes;
          // move start date back 1 day
          start_date.setDate(start_date.getDate() - 1);
        }else if(minutes >= 24*60){
          // business minutes are in next day
          minutes = minutes - 24*60;
          start_date.setDate(start_date.getDate() + 1);
        }
        $booking_form_element.find('.reservo_start_date').val(start_date.toISOString().split('T')[0])
        $booking_form_element.find('.reservo_start_time').val(minutes);
        reservo_show_next_btn($booking_form_element);
        reservo_reload_summary($booking_form_element, 'time', selected_timeslot_time);
      }
    }
    return false;
  });
}

function reservo_init_monthly_calendar_navigation(){
  jQuery('.os-month-next-btn').on('click', function(){
    var $booking_form_element = jQuery(this).closest('.reservo-booking-form-element');
    var next_month_route_name = jQuery(this).data('route');
    if($booking_form_element.find('.os-monthly-calendar-days-w.active + .os-monthly-calendar-days-w').length){
      $booking_form_element.find('.os-monthly-calendar-days-w.active').removeClass('active').next('.os-monthly-calendar-days-w').addClass('active');
      reservo_calendar_set_month_label($booking_form_element);
    }else{
      // TODO add condition to check maximum number months to call into the future
      if(true){
        var $btn = jQuery(this);
        $btn.addClass('os-loading');
        var $calendar_element = $booking_form_element.find('.os-monthly-calendar-days-w').last();
        var calendar_year = $calendar_element.data('calendar-year');
        var calendar_month = $calendar_element.data('calendar-month');
        if(calendar_month == 12){
          calendar_year = calendar_year + 1;
          calendar_month = 1;
        }else{
          calendar_month = calendar_month + 1;
        }
        var params = $booking_form_element.find('.reservo-form').serialize() + '&target_date_string=' + calendar_year + '-' + calendar_month + '-1';
        var data = { action: reservo_helper.route_action, route_name: next_month_route_name, params: params, layout: 'none', return_format: 'json' }
        jQuery.ajax({
          type : "post",
          dataType : "json",
          url : reservo_helper.ajaxurl,
          data : data,
          success: function(data){
            $btn.removeClass('os-loading');
            if(data.status === "success"){
              $booking_form_element.find('.os-months').append(data.message);
              $booking_form_element.find('.os-monthly-calendar-days-w.active').removeClass('active').next('.os-monthly-calendar-days-w').addClass('active');
              reservo_calendar_set_month_label($booking_form_element);
            }else{
              // console.log(data.message);
            }
          }
        });
      }
    }
    reservo_calendar_show_or_hide_prev_next_buttons($booking_form_element);
    return false;
  });
  jQuery('.os-month-prev-btn').on('click', function(){
    var $booking_form_element = jQuery(this).closest('.reservo-booking-form-element');
    if($booking_form_element.find('.os-monthly-calendar-days-w.active').prev('.os-monthly-calendar-days-w').length){
      $booking_form_element.find('.os-monthly-calendar-days-w.active').removeClass('active').prev('.os-monthly-calendar-days-w').addClass('active');
      reservo_calendar_set_month_label($booking_form_element);
    }
    reservo_calendar_show_or_hide_prev_next_buttons($booking_form_element);
    return false;
  });
}

function reservo_calendar_set_month_label($booking_form_element){
  $booking_form_element.find('.os-current-month-label .current-year').text($booking_form_element.find('.os-monthly-calendar-days-w.active').data('calendar-year'));
  $booking_form_element.find('.os-current-month-label .current-month').text($booking_form_element.find('.os-monthly-calendar-days-w.active').data('calendar-month-label'));
}


function reservo_calendar_show_or_hide_prev_next_buttons($booking_form_element){
  $booking_form_element.find('.os-current-month-label .current-year').text($booking_form_element.find('.os-monthly-calendar-days-w.active .os-monthly-calendar-days').data('calendar-year'));
  $booking_form_element.find('.os-current-month-label .current-month').text($booking_form_element.find('.os-monthly-calendar-days-w.active .os-monthly-calendar-days').data('calendar-month-label'));

  if($booking_form_element.find('.os-monthly-calendar-days-w.active').prev('.os-monthly-calendar-days-w').length){
    $booking_form_element.find('.os-month-prev-btn').removeClass('disabled');
  }else{
    $booking_form_element.find('.os-month-prev-btn').addClass('disabled');
  }
}

function reservo_format_minutes_to_time(minutes, service_duration){
  var ampm = reservo_am_or_pm(minutes);
  var formatted_time = reservo_minutes_to_hours_and_minutes(minutes)+' '+ampm;
  if(reservo_show_booking_end_time()){
    var end_minutes = minutes + service_duration;
    var end_minutes_ampm = reservo_am_or_pm(end_minutes);
    formatted_time+= ' - ' + reservo_minutes_to_hours_and_minutes(end_minutes)+' '+end_minutes_ampm;
  }
  formatted_time = formatted_time.trim();
  return formatted_time;
}

function reservo_init_step_datepicker(){
  reservo_init_timeslots();
  reservo_init_monthly_calendar_navigation();
  jQuery('.os-months').on('click', '.os-day', function(){
    if(jQuery(this).hasClass('os-day-passed')) return false;
    if(jQuery(this).hasClass('os-not-in-allowed-period')) return false;
    var $booking_form_element = jQuery(this).closest('.reservo-booking-form-element');
    if(jQuery(this).closest('.os-monthly-calendar-days-w').hasClass('hide-if-single-slot')){

      // HIDE TIMESLOT IF ONLY ONE TIMEPOINT
      if(jQuery(this).hasClass('os-not-available')){
        // clicked on a day that has no available timeslots
        // do nothing
      }else{
        $booking_form_element.find('.os-day.selected').removeClass('selected');
        jQuery(this).addClass('selected');
        // set date
        $booking_form_element.find('.reservo_start_date').val(jQuery(this).data('date'));
        reservo_reload_summary($booking_form_element, 'date', jQuery(this).data('nice-date'));
        if(jQuery(this).hasClass('os-one-slot-only')){
          // clicked on a day that has only one slot available
          var bookable_minutes = jQuery(this).data('bookable-minutes').toString().split(':')[0];
          var selected_timeslot_time = reservo_format_minutes_to_time(Number(bookable_minutes), Number(jQuery(this).data('service-duration')));
          $booking_form_element.find('.reservo_start_time').val(jQuery(this).data('bookable-minutes'));
          reservo_show_next_btn($booking_form_element);
          reservo_reload_summary($booking_form_element, 'time', selected_timeslot_time);
          $booking_form_element.find('.time-selector-w').slideUp(200);
        }else{
          // regular day with more than 1 timeslots available
          // build timeslots
          day_timeslots(jQuery(this));
          // initialize timeslots events
          reservo_init_timeslots();
          // clear time and hide next btn
          $booking_form_element.find('.reservo_start_time').val('');
          reservo_hide_next_btn($booking_form_element);
        }
      }
    }else{

      // SHOW TIMESLOTS EVEN IF ONLY ONE TIMEPOINT
      $booking_form_element.find('.reservo_start_date').val(jQuery(this).data('date'));
      reservo_reload_summary($booking_form_element, 'date', jQuery(this).data('nice-date'));
      $booking_form_element.find('.os-day.selected').removeClass('selected');
      jQuery(this).addClass('selected');

      // build timeslots
      day_timeslots(jQuery(this));
      // initialize timeslots events
      reservo_init_timeslots();
      // clear time and hide next btn
      reservo_reload_summary($booking_form_element, 'time', '');
      $booking_form_element.find('.reservo_start_time').val('');
      reservo_hide_next_btn($booking_form_element);
    }


    return false;
  });
}


function reservo_init_step_verify($booking_form_element = false){
  if(!$booking_form_element) return;

  $booking_form_element.closest('.reservo-summary-is-open').removeClass('reservo-summary-is-open');
}


function reservo_init_step_payment($booking_form_element = false){
  if($booking_form_element.find('.step-payment-w').data('full-amount') > 0){
    reservo_reload_summary($booking_form_element, 'price', reservo_format_price(($booking_form_element.find('.step-payment-w').data('full-amount') * 100 / 100).toFixed(reservo_helper.number_of_decimals)));
  }
  if($booking_form_element && ($booking_form_element.find('.step-payment-w').data('default-portion') == 'deposit')){
    $booking_form_element.find('input[name="booking[payment_portion]"]').val('deposit');
  }

  // activate payment method content if method and portion are set and no selection is needed
  var selected_payment_method = $booking_form_element.find('input[name="booking[payment_method]"]').val();
  if(selected_payment_method && !jQuery('.lp-payment-times-w').length && !jQuery('.lp-payment-methods-w').length && !jQuery('.lp-payment-portions-w').length){
    reservo_init_payment_method_actions($booking_form_element, selected_payment_method);
  }

  jQuery('.reservo-booking-form-element .coupon-code-input-submit').on('click', function(e){
    reservo_apply_coupon(jQuery(this).closest('.coupon-code-input-w').find('.coupon-code-input'));
    return false;
  });

  jQuery('.reservo-booking-form-element .coupon-code-clear').on('click', function(e){
    reservo_remove_coupon(jQuery(this));
    return false;
  });

  jQuery('.reservo-booking-form-element input.coupon-code-input').on('keyup', function(e){
    if(e.which === 13){
      reservo_apply_coupon(jQuery(this));
      return false;
    }
  });


  jQuery('.reservo-booking-form-element .coupon-code-trigger-w a').on('click', function(e){
    jQuery(this).closest('.payment-total-info').addClass('entering-coupon').find('.coupon-code-input').focus();
    return false;
  });


  // Pay later button click
  jQuery('.reservo-booking-form-element .lp-payment-trigger-later').on('click', function(e){
    var $booking_form_element = jQuery(this).closest('.reservo-booking-form-element');
    $booking_form_element.find('input[name="booking[payment_method]"]').val(jQuery(this).data('method'));
    $booking_form_element.find('input[name="booking[payment_portion]"]').val('');
    $booking_form_element.find('.reservo-form').submit();
  });


  // Selecting Payment Time
  jQuery('.reservo-booking-form-element .lp-payment-trigger-payment-time-selector').on('click', function(e){
    var $booking_form_element = jQuery(this).closest('.reservo-booking-form-element');
    var $payment_step = $booking_form_element.find('.step-payment-w');

    reservo_hide_next_btn($booking_form_element);
    reservo_show_prev_btn($booking_form_element);
    $payment_step.attr('data-sub-step', reservo_get_payment_sub_step($booking_form_element, $payment_step.attr('data-sub-step')));
    return false;
  });

  // Selecting Payment Method
  jQuery('.reservo-booking-form-element .lp-payment-trigger-payment-method-selector').on('click', function(e){
    var $booking_form_element = jQuery(this).closest('.reservo-booking-form-element');
    var selected_payment_method = jQuery(this).data('method');
    $booking_form_element.find('input[name="booking[payment_method]"]').val(selected_payment_method);

    var $payment_step = $booking_form_element.find('.step-payment-w');
    reservo_hide_next_btn($booking_form_element);
    reservo_show_prev_btn($booking_form_element);
    $payment_step.attr('data-sub-step', reservo_get_payment_sub_step($booking_form_element, $payment_step.attr('data-sub-step')));
  });

  jQuery('.reservo-booking-form-element .lp-payment-trigger-payment-portion-selector').on('click', function(e){
    var $booking_form_element = jQuery(this).closest('.reservo-booking-form-element');
    var portion = jQuery(this).data('portion');
    $booking_form_element.find('input[name="booking[payment_portion]"]').val(portion);
    if(portion == 'deposit'){
      $booking_form_element.find('.payment-total-info').addClass('paying-deposit');
    }else{
      $booking_form_element.find('.payment-total-info').removeClass('paying-deposit');
    }

    var $payment_step = $booking_form_element.find('.step-payment-w');
    reservo_hide_next_btn($booking_form_element);
    reservo_show_prev_btn($booking_form_element);
    $payment_step.attr('data-sub-step', reservo_get_payment_sub_step($booking_form_element, $payment_step.attr('data-sub-step')));
  });


}


function reservo_init_step_category_items(step_name){
  jQuery('.reservo-step-content[data-step-name="' + step_name + '"] .os-item-category-info').on('click', function(){
    var $booking_form_element = jQuery(this).closest('.reservo-booking-form-element');
    reservo_show_prev_btn($booking_form_element);
    jQuery(this).closest('.reservo-step-content').addClass('selecting-item-category');
    var $category_wrapper = jQuery(this).closest('.os-item-category-w');
    var $main_parent = jQuery(this).closest('.os-item-categories-main-parent');
    if($category_wrapper.hasClass('selected')){
      $category_wrapper.removeClass('selected');
      if($category_wrapper.parent().closest('.os-item-category-w').length){
        $category_wrapper.parent().closest('.os-item-category-w').addClass('selected');
      }else{
        $main_parent.removeClass('show-selected-only');
      }
    }else{
      $main_parent.find('.os-item-category-w.selected').removeClass('selected');
      $main_parent.addClass('show-selected-only');
      $category_wrapper.addClass('selected');
    }
    return false;
  });
}


function reservo_init_step_selectable_items(){
  jQuery('.os-selectable-items .os-selectable-item').off('click', reservo_selectable_item_clicked);
  jQuery('.os-selectable-items .os-selectable-item').on('click', reservo_selectable_item_clicked);

  jQuery('.os-selectable-items .os-selectable-item .item-quantity-selector-input').off('keyup', reservo_selectable_item_quantity_keyup);
  jQuery('.os-selectable-items .os-selectable-item .item-quantity-selector-input').on('keyup', reservo_selectable_item_quantity_keyup);
}


function reservo_update_quantity_for_selectable_items($item){
    var ids = $item.closest('.os-selectable-items')
                      .find('.os-selectable-item.selected')
                      .map(function(){
                        if(jQuery(this).hasClass('has-quantity')){
                          return jQuery(this).data('item-id') + ':' + jQuery(this).find('input.item-quantity-selector-input').val();
                        }else{
                          return jQuery(this).data('item-id');
                        }
                      }).get();
    $item.closest('.reservo-booking-form-element').find($item.data('id-holder')).val(ids);
}

function reservo_selectable_item_quantity_keyup(event){
  var $booking_form_element = jQuery(this).closest('.reservo-booking-form-element');
  var $item = jQuery(this).closest('.os-selectable-item');
  var new_value = jQuery(this).val();
  if(new_value && new_value.match(/^\d+$/)){
    var max_quantity = $item.data('max-quantity');
    if(max_quantity && (new_value > max_quantity)) new_value = max_quantity;
  }else{
    new_value = 0;
  }
  jQuery(this).val(new_value);

  if(( $item.hasClass('selected') && (new_value > 0) ) || (!$item.hasClass('selected') && (new_value == 0))){
    reservo_update_quantity_for_selectable_items($item);
    reservo_reload_summary($booking_form_element);
    return false;
  }else{
    $item.trigger('click');
  }
}

function reservo_selectable_item_clicked(event){
  event.stopPropagation();
  event.stopImmediatePropagation();
  var $booking_form_element = jQuery(this).closest('.reservo-booking-form-element');
  if(jQuery(this).hasClass('has-quantity')){
    if(jQuery(event.target).hasClass('item-quantity-selector')){
      var current_value = parseInt(jQuery(this).find('input.item-quantity-selector-input').val());
      var new_value = (jQuery(event.target).data('sign') == 'minus') ? current_value - 1 : current_value + 1;
      var max_quantity = jQuery(this).data('max-quantity');
      if(new_value < 0) new_value = 0;
      if(max_quantity && (new_value > max_quantity)) new_value = max_quantity;
      jQuery(this).find('input.item-quantity-selector-input').val(new_value);
      if(( jQuery(this).hasClass('selected') && (new_value > 0) ) || (!jQuery(this).hasClass('selected') && (new_value == 0))){
        reservo_update_quantity_for_selectable_items(jQuery(this));
        reservo_reload_summary($booking_form_element);
        return false;
      }
    }
    if(jQuery(event.target).hasClass('item-quantity-selector-input')){
      reservo_update_quantity_for_selectable_items(jQuery(this));
      reservo_reload_summary($booking_form_element);
      return false;
    }
  }
  var summary_value = '';
  if(jQuery(this).hasClass('os-allow-multiselect')){
    if(jQuery(this).hasClass('selected')){
      jQuery(this).removeClass('selected');
      if(jQuery(this).hasClass('has-quantity')) jQuery(this).find('input.item-quantity-selector-input').val(0);
    }else{
      jQuery(this).addClass('selected');
      if(jQuery(this).hasClass('has-quantity') && !(jQuery(this).find('input.item-quantity-selector-input').val() > 0)){
        jQuery(this).find('input.item-quantity-selector-input').val(1);
      }
    }
    reservo_update_quantity_for_selectable_items(jQuery(this));
    summary_value = String(jQuery(this).closest('.os-selectable-items').find('.os-selectable-item.selected').map(function(){ return (' ' + jQuery(this).data('summary-value')); }).get()).trim();
    reservo_show_next_btn($booking_form_element);
  }else{
    if(!jQuery(this).hasClass('os-duration-item')) jQuery(this).closest('.os-item-categories-main-parent').find('.os-selectable-item.selected').removeClass('selected');
    jQuery(this).closest('.os-selectable-items').find('.os-selectable-item.selected').removeClass('selected');
    jQuery(this).addClass('selected');
    $booking_form_element.find(jQuery(this).data('id-holder')).val(jQuery(this).data('item-id'));
    summary_value = jQuery(this).data('summary-value');
    if(jQuery(this).data('os-call-func')){
      window[jQuery(this).data('os-call-func')](jQuery(this));
    }
    if(jQuery(this).data('activate-sub-step')){
      window[jQuery(this).data('activate-sub-step')](jQuery(this));
    }else{
      reservo_trigger_next_btn($booking_form_element);
    }
  }
  reservo_reload_summary($booking_form_element, jQuery(this).data('summary-field-name'), summary_value);
}


function reservo_format_price(price){
  // replace default decimal separator dot with comma if it's in settings
  if(reservo_helper.decimal_separator == ',') price = String(price).replace('.', ',');
  return reservo_helper.currency_symbol_before + String(price) + reservo_helper.currency_symbol_after;
}


function reservo_init_step_services(){
  jQuery('.total-attendies-selector-input').on('change', function(){
    var max_capacity = jQuery(this).closest('.total-attendies-selector-w').data('max-capacity');
    var min_capacity = jQuery(this).closest('.total-attendies-selector-w').data('min-capacity');
    var new_value = jQuery(this).val();
    new_value = Math.min(Number(max_capacity), Number(new_value));
    new_value = Math.max(Number(min_capacity), Number(new_value));
    jQuery(this).val(new_value);
    var new_value_formatted = new_value + ' ' + ((new_value > 1) ? jQuery(this).data('summary-plural') : jQuery(this).data('summary-singular'));

    var $booking_form_element = jQuery(this).closest('.reservo-booking-form-element');
    reservo_reload_summary($booking_form_element, 'total-attendies', new_value_formatted);
  });
  jQuery('.total-attendies-selector').on('click', function(){
    var add_value = (jQuery(this).hasClass('total-attendies-selector-plus')) ? 1 : -1;
    var max_capacity = jQuery(this).closest('.total-attendies-selector-w').data('max-capacity');
    var min_capacity = jQuery(this).closest('.total-attendies-selector-w').data('min-capacity');
    var current_value = jQuery(this).closest('.total-attendies-selector-w').find('input.total-attendies-selector-input').val();
    var new_value = (Number(current_value) > 0) ? Math.max((Number(current_value) + add_value), 1) : 1;
    new_value = Math.min(Number(max_capacity), new_value);
    new_value = Math.max(Number(min_capacity), new_value);
    jQuery(this).closest('.total-attendies-selector-w').find('input').val(new_value).trigger('change');
    return false;
  });
}


function reservo_trigger_next_btn($booking_form_element){
  $booking_form_element.find('.reservo_step_direction').val('next');
  $booking_form_element.find('.reservo-form').submit();
}

function reservo_init_step_locations(){
}

function reservo_init_step_agents(){
  jQuery('.os-items .os-item-details-btn').on('click', function(){
    var $booking_form_element = jQuery(this).closest('.reservo-booking-form-element');
    var agent_id = jQuery(this).data('agent-id');
    $booking_form_element.find('.os-agent-bio-popup.active').removeClass('active');
    $booking_form_element.find('#osAgentBioPopup' + agent_id).addClass('active');
    return false;
  });
  jQuery('.os-agent-bio-close').on('click', function(){
    jQuery(this).closest('.os-agent-bio-popup').removeClass('active');
    return false;
  });
}

function reservo_init_booking_summary_lightbox(){
  jQuery('.customer-dashboard-booking-summary-lightbox').on('click', '.qr-show-trigger', function(){
    jQuery(this).closest('.reservo-lightbox-i').find('.qr-code-on-confirmation').addClass('show-vevent-qr-code');
    return false;
  });
}

function reservo_init_step_confirmation(){

  jQuery('.reservo-booking-form-element').on('click', '.set-customer-password-btn', function(){
    var $btn = jQuery(this);
    var $booking_form_element = jQuery(this).closest('.reservo-booking-form-element');

    $btn.addClass('os-loading');
    var params = { account_nonse: jQuery('input[name="account_nonse"]').val(), password: jQuery('input[name="customer[password]"]').val(), password_confirmation: jQuery('input[name="customer[password_confirmation]"]').val()}
    var data = { action: reservo_helper.route_action, route_name: jQuery(this).data('btn-action'), params: jQuery.param(params), layout: 'none', return_format: 'json' }
    jQuery.ajax({
      type : "post",
      dataType : "json",
      url : reservo_helper.ajaxurl,
      data : data,
      success: function(data){
        $btn.removeClass('os-loading');
        if(data.status === "success"){
          $booking_form_element.find('.step-confirmation-set-password').html('').hide();
          $booking_form_element.find('.confirmation-cabinet-info').show();
        }else{
          reservo_show_message_inside_element(data.message, $booking_form_element.find('.step-confirmation-set-password'), 'error');
        }
      }
    });
    return false;
  });

  jQuery('.reservo-booking-form-element').on('click', '.qr-show-trigger', function(){
    var $booking_form_element = jQuery(this).closest('.reservo-booking-form-element');
    $booking_form_element.find('.qr-code-on-confirmation').addClass('show-vevent-qr-code');
    return false;
  });

  jQuery('.reservo-booking-form-element').on('click', '.show-set-password-fields', function(){
    var $booking_form_element = jQuery(this).closest('.reservo-booking-form-element');

    $booking_form_element.find('.step-confirmation-set-password').show();
    $booking_form_element.find('#customer_password').focus();
    jQuery(this).closest('.info-box').hide();
    return false;
  });
}

function reservo_init_customer_dashboard(){
  reservo_init_form_masks();
  jQuery('.reservo-customer-timezone-selector-w select').on('change', function(e){
    var $select_box = jQuery(this);
    $select_box.closest('.reservo-customer-timezone-selector-w').addClass('os-loading');
    var data = { action: reservo_helper.route_action, route_name: jQuery(this).closest('.reservo-customer-timezone-selector-w').data('route-name'), params: { timezone_name: jQuery(this).val()}, layout: 'none', return_format: 'json'}
    jQuery.ajax({
      type : "post",
      dataType : "json",
      url : reservo_helper.ajaxurl,
      data : data,
      success: function(data){
        $select_box.closest('.reservo-customer-timezone-selector-w').removeClass('os-loading');
        if(data.status === "success"){
          location.reload();
        }else{

        }
      }
    });
  });
}

function reservo_init_customer_dashboard_login(){
  if(jQuery('.reservo-login-form-w #facebook-signin-btn').length && jQuery('.reservo-login-form-w').length){
    jQuery('.reservo-login-form-w #facebook-signin-btn').on('click', function(){
      var $login_form_wrapper = jQuery(this).closest('.reservo-login-form-w');
      FB.login(function(response){
        if (response.status === 'connected' && response.authResponse) {
          var params = { token: response.authResponse.accessToken};
          var data = { action: reservo_helper.route_action, route_name: $login_form_wrapper.find('#facebook-signin-btn').data('login-action'), params: jQuery.param(params), layout: 'none', return_format: 'json' };
          reservo_step_content_change_start($login_form_wrapper);
          jQuery.ajax({
            type : "post",
            dataType : "json",
            url : reservo_helper.ajaxurl,
            data : data,
            success: function(data){
              if(data.status === "success"){
                location.reload();
              }else{
                reservo_show_message_inside_element(data.message, $login_form_wrapper);
                reservo_step_content_change_end(false, $login_form_wrapper);
              }
            }
          });
        } else {

        }
      }, {scope: 'public_profile,email'});
    });
  }

  if(jQuery('.reservo-login-form-w #google-signin-btn').length && jQuery('.reservo-login-form-w').length && typeof google !== 'undefined'){
    // INIT GOOGLE LOGIN
    var googleUser = {};

    var $login_form_wrappers = jQuery('.reservo-login-form-w');
    $login_form_wrappers.each(function(){
      var $login_form_wrapper = jQuery(this);
      google.accounts.id.initialize({
        client_id: reservo_helper.social_login_google_client_id,
        callback: reservo_process_google_login
      });
      google.accounts.id.renderButton(
        $login_form_wrapper.find('#google-signin-btn')[0],
        {theme: "outline", size: "medium"}  // customization attributes
      );
    });
  }
}

function get_customer_name($wrapper){
  var customer_name = '';
  var first_name = $wrapper.find('input[name="customer[first_name]"]').val();
  var last_name = $wrapper.find('input[name="customer[last_name]"]').val();
  if(first_name) customer_name+= first_name;
  if(last_name) customer_name+= ' ' + last_name;
  return customer_name.trim();
}

function reservo_init_step_contact(){
  reservo_init_facebook_login();
  reservo_init_google_login();
  reservo_init_form_masks();

  jQuery('.step-contact-w').each(function(){
    reservo_reload_summary(jQuery(this).closest('.reservo-booking-form-element'), 'customer', get_customer_name(jQuery(this)));
  });

  jQuery('.step-contact-w').on('keyup', 'input[name="customer[first_name]"], input[name="customer[last_name]"]', function(){
    var $booking_form_element = jQuery(this).closest('.reservo-booking-form-element');
    reservo_reload_summary($booking_form_element, 'customer', get_customer_name($booking_form_element));
  });

  jQuery('.step-contact-w').on('keyup', '.os-form-control.required', function(){
    var $booking_form_element = jQuery(this).closest('.reservo-booking-form-element');
    if(reservo_validate_fields($booking_form_element.find('.step-contact-w .os-form-control.required'))){
    }else{
    }
  });

  // Init Logout button
  jQuery('.step-customer-logout-btn').on('click', function(){
    var $booking_form_element = jQuery(this).closest('.reservo-booking-form-element');
    var data = { action: reservo_helper.route_action, route_name: jQuery(this).data('btn-action'), layout: 'none', return_format: 'json' }
    reservo_step_content_change_start($booking_form_element);
    jQuery.ajax({
      type : "post",
      dataType : "json",
      url : reservo_helper.ajaxurl,
      data : data,
      success: function(data){
        reservo_reload_step($booking_form_element);
      }
    });
    return false;
  });

  // Init Login Existing Customer Button
  jQuery('.step-login-existing-customer-btn').on('click', function(){
    var $booking_form_element = jQuery(this).closest('.reservo-booking-form-element');
    var params = { email: $booking_form_element.find('.os-step-existing-customer-login-w input[name="customer_login[email]"]').val(), password: $booking_form_element.find('.os-step-existing-customer-login-w input[name="customer_login[password]"]').val()}
    var data = { action: reservo_helper.route_action, route_name: jQuery(this).data('btn-action'), params: jQuery.param(params), layout: 'none', return_format: 'json' }
    reservo_step_content_change_start($booking_form_element);
    jQuery.ajax({
      type : "post",
      dataType : "json",
      url : reservo_helper.ajaxurl,
      data : data,
      success: function(data){
          if(data.status === "success"){
            reservo_reload_step($booking_form_element);
          }else{
            reservo_show_message_inside_element(data.message, $booking_form_element.find('.os-step-existing-customer-login-w'));
            reservo_step_content_change_end(false, $booking_form_element);
          }
      }
    });
    return false;
  });
}

function reservo_step_content_change_start($booking_form_element){
  $booking_form_element.removeClass('step-content-loaded').addClass('step-content-loading');
}

// TODO
function reservo_step_content_change_end(new_content, $booking_form_element){
  if(new_content) $booking_form_element.find('.reservo-body .reservo-step-content').replaceWith(new_content);
  $booking_form_element.removeClass('step-content-loading').addClass('step-content-mid-loading');
  setTimeout(function(){
    $booking_form_element.removeClass('step-content-mid-loading').addClass('step-content-loaded');
  }, 50);
}

function reservo_init_facebook_login(){
  if(!jQuery('#facebook-signin-btn').length || !jQuery('.reservo-booking-form-element').length) return;
  jQuery('#facebook-signin-btn').on('click', function(){
    var $booking_form_element = jQuery(this).closest('.reservo-booking-form-element');
    FB.login(function(response){
      if (response.status === 'connected' && response.authResponse) {
        var params = { token: response.authResponse.accessToken};
        var data = { action: reservo_helper.route_action, route_name: $booking_form_element.find('#facebook-signin-btn').data('login-action'), params: jQuery.param(params), layout: 'none', return_format: 'json' };
        reservo_step_content_change_start($booking_form_element);
        jQuery.ajax({
          type : "post",
          dataType : "json",
          url : reservo_helper.ajaxurl,
          data : data,
          success: function(data){
            if(data.status === "success"){
              reservo_reload_step($booking_form_element);
            }else{
              reservo_show_message_inside_element(data.message, $booking_form_element.find('.os-step-existing-customer-login-w '));
              reservo_step_content_change_end(false, $booking_form_element);
            }
          }
        });
      } else {

      }
    }, {scope: 'public_profile,email'});
  });
}

function reservo_process_google_login(response, $booking_form_element = false){

  var params = {
   token: response.credential
  };
  var data = {
   action: reservo_helper.route_action,
   route_name: reservo_helper.social_login_google_route,
   params: jQuery.param(params),
   layout: 'none',
   return_format: 'json'
  };
  if($booking_form_element) reservo_step_content_change_start($booking_form_element);
  jQuery.ajax({
    type : "post",
    dataType : "json",
    url : reservo_helper.ajaxurl,
    data : data,
    success: function(data){
      if(data.status === "success"){
        if($booking_form_element){
          reservo_reload_step($booking_form_element);
        }else{
          location.reload();
        }
      }else{
        reservo_show_message_inside_element(data.message, $booking_form_element.find('.os-step-existing-customer-login-w '));
        reservo_step_content_change_end(false, $booking_form_element);
      }
    }
  });
}

function reservo_init_google_login(){
  if(!jQuery('#google-signin-btn').length || !jQuery('.reservo-booking-form-element').length || typeof google === 'undefined') return;
  var googleUser = {};

  var $booking_form_elements = jQuery('.reservo-booking-form-element');
  $booking_form_elements.each(function(){
    var $booking_form_element = jQuery(this);
    google.accounts.id.initialize({
      client_id: reservo_helper.social_login_google_client_id,
      callback: (response) => reservo_process_google_login(response, $booking_form_element)
    });
    google.accounts.id.renderButton(
      $booking_form_element.find('#google-signin-btn')[0],
      {theme: "outline", size: "medium"}  // customization attributes
    );
  });
}

function reservo_change_step_desc($booking_form_element, step_name){
  $booking_form_element.removeClass('step-changed').addClass('step-changing');
  setTimeout(function(){
    // Progress bar
    var $step_progress = $booking_form_element.find('.reservo-progress li[data-step-name="' + step_name + '"]');
    $step_progress.addClass('active').addClass('complete').prevAll().addClass('complete').removeClass('active');
    $step_progress.nextAll().removeClass('complete').removeClass('active');
    // Side panel
    var side_panel_desc = $booking_form_element.find('.reservo-step-desc-library[data-step-name="' + step_name + '"]').html();
    $booking_form_element.find('.reservo-step-desc').html(side_panel_desc);

    // Top header
    var top_header_desc = $booking_form_element.find('.os-heading-text-library[data-step-name="' + step_name + '"]').html();
    $booking_form_element.find('.os-heading-text').html(top_header_desc);
    setTimeout(function(){
        $booking_form_element.removeClass('step-changing').addClass('step-changed');
    }, 50);
  }, 500);
}


function reservo_progress_prev($booking_form_element, step_name){
  var $step_progress = $booking_form_element.find('.reservo-progress li[data-step-name="' + step_name + '"]');
  $step_progress.addClass('active').addClass('complete').prevAll().addClass('complete').removeClass('active');
  $step_progress.nextAll().removeClass('complete').removeClass('active');
}


function reservo_progress_next($booking_form_element, step_name){
  var $step_progress = $booking_form_element.find('.reservo-progress li[data-step-name="' + step_name + '"]');
  $step_progress.addClass('active').addClass('complete').prevAll().addClass('complete').removeClass('active');
  $step_progress.nextAll().removeClass('complete').removeClass('active');
}


function reservo_next_step_description($booking_form_element, step_name){
  $booking_form_element.removeClass('step-changed').addClass('step-changing');
  setTimeout(function(){
    $booking_form_element.find('.reservo-step-desc').html($booking_form_element.find('.reservo-step-desc-library.active').removeClass('active').next('.reservo-step-desc-library').addClass('active').html());
    $booking_form_element.find('.os-heading-text').html($booking_form_element.find('.os-heading-text-library.active').removeClass('active').next('.os-heading-text-library').addClass('active').html());
    setTimeout(function(){
      $booking_form_element.removeClass('step-changing').addClass('step-changed');
    }, 50);
  }, 500);
}
function reservo_prev_step_description($booking_form_element, step_name){
  $booking_form_element.removeClass('step-changed').addClass('step-changing');
  setTimeout(function(){
    $booking_form_element.find('.reservo-step-desc').html($booking_form_element.find('.reservo-step-desc-library.active').removeClass('active').prev('.reservo-step-desc-library').addClass('active').html());
    $booking_form_element.find('.os-heading-text').html($booking_form_element.find('.os-heading-text-library.active').removeClass('active').prev('.os-heading-text-library').addClass('active').html());
    setTimeout(function(){
      $booking_form_element.removeClass('step-changing').addClass('step-changed');
    }, 50);
  }, 500);
}


function reservo_validate_fields($fields){
  var is_valid = true;
  $fields.each(function(index){
    if(jQuery(this).val() == ''){
      is_valid = false;
      return false;
    }
  });
  return is_valid;
}


function reservo_submit_booking_form($booking_form){
  var $booking_form_element = $booking_form.closest('.reservo-booking-form-element');

  $booking_form_element.removeClass('step-content-loaded').addClass('step-content-loading');
  jQuery.ajax({
    type : "post",
    dataType : "json",
    processData: false,
    contentType: false,
    url : reservo_helper.ajaxurl,
    data : reservo_create_form_data_from_booking_form($booking_form),
    success: function(data){
      if(data.status === "success"){
        reservo_hide_message_inside_element($booking_form_element.find('.reservo-body'));
        if($booking_form_element.data('flash-error')){
          reservo_show_message_inside_element($booking_form_element.data('flash-error'), $booking_form_element.find('.reservo-body'));
          $booking_form_element.data('flash-error', '');
        }
        $booking_form_element.find('.reservo_current_step').val(data.step_name);
        $booking_form_element.removeClass(function (index, className) { return (className.match (/(^|\s)current-step-\S+/g) || []).join(' '); }).addClass('current-step-' + data.step_name);
        setTimeout(function(){
          $booking_form_element.removeClass('step-content-loading').addClass('step-content-mid-loading');
          $booking_form_element.find('.reservo-body').find('.reservo-step-content').addClass('is-hidden');
          if($booking_form_element.find('.reservo-step-content[data-step-name="'+ data.step_name +'"]')){
            $booking_form_element.find('.reservo-step-content[data-step-name="'+ data.step_name +'"]').remove();
          }
          $booking_form_element.find('.reservo-body').append(data.message);

          reservo_init_step(data.step_name, $booking_form_element);
          setTimeout(function(){
            $booking_form_element.removeClass('step-content-mid-loading').addClass('step-content-loaded');
            $booking_form_element.find('.reservo-next-btn, .reservo-prev-btn').removeClass('os-loading');
          }, 50);
        }, 500);

        if(data.is_pre_last_step){
          $booking_form_element.data('next-submit-is-last', 'yes');
          $booking_form_element.find('.reservo-next-btn span').text($booking_form_element.find('.reservo-next-btn').data('pre-last-step-label'));
        }else{
          $booking_form_element.data('next-submit-is-last', 'no');
          $booking_form_element.find('.reservo-next-btn span').text($booking_form_element.find('.reservo-next-btn').data('label'));
        }
        if(data.is_last_step){
          $booking_form_element.addClass('hidden-buttons').find('.reservo-footer').remove();
          $booking_form_element.find('.reservo-progress').css( 'opacity', 0 );
          $booking_form_element.closest('.reservo-summary-is-open').removeClass('reservo-summary-is-open');
          $booking_form_element.addClass('is-final-step');
        }else{
          if(data.show_next_btn === true){
            reservo_show_next_btn($booking_form_element);
          }else{
            reservo_hide_next_btn($booking_form_element);
          }
          if(data.show_prev_btn === true){
            reservo_show_prev_btn($booking_form_element);
          }else{
            reservo_hide_prev_btn($booking_form_element);
          }
        }
        reservo_change_step_desc($booking_form_element, data.step_name);
      }else{
        $booking_form_element.removeClass('step-content-loading').addClass('step-content-loaded');
        $booking_form_element.find('.reservo-next-btn, .reservo-prev-btn').removeClass('os-loading');
        if(data.send_to_step && $booking_form_element.find('.reservo-step-content[data-step-name="'+ data.send_to_step +'"]').length){
          $booking_form_element.data('flash-error', data.message);
          reservo_reload_step($booking_form_element, data.send_to_step);
        }else{
          reservo_show_message_inside_element(data.message, $booking_form_element.find('.reservo-body'));
          reservo_show_prev_btn($booking_form_element);
        }
      }
      $booking_form.find('.reservo_step_direction').val('next');
    }
  });
}

function reservo_init_booking_form($booking_form_element){

  $booking_form_element.find('.reservo-form').on('submit', function(e){
    e.preventDefault();
    var $booking_form = jQuery(this);
    reservo_hide_prev_btn($booking_form_element);
    var current_step = $booking_form_element.find('.reservo_current_step').val();
    var callbacks_list = [];
    $booking_form_element.trigger('reservo:submitBookingForm', [{ current_step: current_step,
                                                                    callbacks_list: callbacks_list,
                                                                    is_final_submit: $booking_form_element.data('next-submit-is-last') == 'yes',
                                                                    direction: $booking_form_element.find('.reservo_step_direction').val()}]);
    jQuery.when(...callbacks_list.map(callback => callback.action()))
      .done(() => {
                    reservo_submit_booking_form($booking_form);
                  })
      .fail((error) => {
        if(error.send_to_step && $booking_form_element.find('.reservo-step-content[data-step-name="'+ error.send_to_step +'"]').length){
          reservo_reload_step($booking_form_element, error.send_to_step);
          $booking_form_element.data('flash-error', error.message);
        }
        $booking_form_element.removeClass('step-content-loading').addClass('step-content-loaded');
        reservo_show_message_inside_element(error.message, $booking_form_element.find('.reservo-body'), 'error');
        $booking_form_element.find('.reservo-next-btn').removeClass('os-loading');
        if($booking_form_element.find('.reservo-step-content:last-child').prev('.reservo-step-content').length) reservo_show_prev_btn($booking_form_element);
      });
  });

  $booking_form_element.find('.reservo-lightbox-summary-trigger').on('click', function(){
    var $wrapper = jQuery(this).closest('.reservo-w');
    $wrapper.toggleClass('show-summary-on-mobile');
    return false;
  });

  $booking_form_element.find('.reservo-lightbox-close').on('click', function(){

    let params = new URLSearchParams(location.search);
    if(params.has('reservo_booking_intent_key')){
      params.delete('reservo_booking_intent_key');
      history.replaceState(null, '', '?' + params + location.hash);
    }

    jQuery('body').removeClass('reservo-lightbox-active');
    jQuery('.reservo-lightbox-w').remove();
    return false;
  });



  $booking_form_element.find('.reservo-timezone-selector-w select').on('change', function(e){
    var $select_box = jQuery(this);
    $select_box.closest('.reservo-timezone-selector-w').addClass('os-loading');
    var data = { action: reservo_helper.route_action, route_name: jQuery(this).closest('.reservo-timezone-selector-w').data('route-name'), params: { timezone_name: jQuery(this).val()}, layout: 'none', return_format: 'json'}
    $booking_form_element.removeClass('step-content-loaded').addClass('step-content-loading');
    jQuery.ajax({
      type : "post",
      dataType : "json",
      url : reservo_helper.ajaxurl,
      data : data,
      success: function(data){
        $select_box.closest('.reservo-timezone-selector-w').removeClass('os-loading');
        $booking_form_element.removeClass('step-content-loading');
        if(data.status === "success"){
          // reload datepicker if its the step
          if($select_box.closest('.reservo-booking-form-element').hasClass('current-step-datepicker')){
            reservo_reload_step($select_box.closest('.reservo-booking-form-element'));
          }
        }else{

        }
      }
    });
  });

  if(!reservo_helper.is_timezone_selected){
    const tzid = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if(tzid){
      if(tzid != $booking_form_element.find('.reservo-timezone-selector-w select').val()) $booking_form_element.find('.reservo-timezone-selector-w select').val(tzid).change();
    }
  }



  $booking_form_element.on('click', '.lp-option', function(){
    jQuery(this).closest('.lp-options').find('.lp-option.selected').removeClass('selected');
    jQuery(this).addClass('selected');
  });




  // Next Step button Click
  $booking_form_element.find('.reservo-next-btn').on('click', function(e){
    if(jQuery(this).hasClass('disabled') || jQuery(this).hasClass('os-loading')) return false;
    var $next_btn = jQuery(this);
    $next_btn.addClass('os-loading');
    var $booking_form = jQuery(this).closest('.reservo-form');

    var current_step = $booking_form_element.find('.reservo_current_step').val();

    $booking_form.find('.reservo_step_direction').val('next');
    var callbacks_list = [];
    $booking_form_element.trigger('reservo:nextStepClicked', [{current_step: current_step, callbacks_list: callbacks_list}]);
    reservo_hide_prev_btn($booking_form_element);
    jQuery.when(...callbacks_list.map(callback => callback.action()))
      .done(() => {
                    $booking_form.submit();
                  })
      .fail((error) => {
        reservo_show_message_inside_element(error.message, $booking_form_element.find('.reservo-body'), 'error');
        $next_btn.removeClass('os-loading');
        // if previous step exists - show prev button
        if($booking_form_element.find('.reservo-step-content:last-child').prev('.reservo-step-content').length) reservo_show_prev_btn($booking_form_element);
      });
    return false;
  });


  // Previous Step button Click
  $booking_form_element.find('.reservo-prev-btn').on('click', function(e){
    if(jQuery(this).hasClass('disabled') || jQuery(this).hasClass('os-loading')) return false;
    var $booking_form = jQuery(this).closest('.reservo-form');

    var current_step = $booking_form_element.find('.reservo_current_step').val();
    var $current_step = $booking_form_element.find('.reservo-step-content[data-step-name="'+current_step+'"]');

    if(current_step == 'locations'){
    }
    if(current_step == 'agents'){
    }
    if(current_step == 'payment'){
      var $payment_step = $booking_form_element.find('.step-payment-w');
      if($payment_step.length){
        $payment_step.find('.lp-option.selected').removeClass('selected');
        var new_sub_step = reservo_get_payment_sub_step($booking_form_element, $payment_step.attr('data-sub-step'), true);
        // hide all payment method content blocks
        if(new_sub_step != $payment_step.attr('data-sub-step')){
          $payment_step.find('.lp-payment-method-content').hide();
          $payment_step.attr('data-sub-step', new_sub_step);
          reservo_hide_next_btn($booking_form_element);
          return false;
        }
      }
    }
    if(current_step == 'services'){
      var $services_step = $booking_form_element.find('.step-services-w');
      if($services_step.hasClass('selecting-service-duration')){
        $services_step.removeClass('selecting-service-duration');
        $services_step.find('.os-services > .os-item.selected').removeClass('selected');
        clear_sub_step_duration($booking_form_element);
        if(($booking_form_element.find('.reservo-step-content').length <= 1) && !$services_step.hasClass('selecting-item-category')){
          reservo_hide_prev_btn($booking_form_element)
        }
        reservo_reload_summary($booking_form_element);
        return false;
      }
      if($services_step.hasClass('selecting-total-attendies')){
        $services_step.removeClass('selecting-total-attendies');
        if($services_step.find('.os-services > .os-item.selected').hasClass('has-multiple-durations')){
          // multiple durations
          $services_step.find('.os-services > .os-item.selected .os-service-durations .os-selectable-item.selected').removeClass('selected');
          $services_step.addClass('selecting-service-duration');
          reservo_hide_next_btn($booking_form_element);
        }else{
          $services_step.find('.os-services > .os-item.selected').removeClass('selected');
        }
        clear_sub_step_attendies($booking_form_element);
        if(($booking_form_element.find('.reservo-step-content').length <= 1) && !$services_step.hasClass('selecting-item-category')){
          reservo_hide_prev_btn($booking_form_element);
        }
        reservo_reload_summary($booking_form_element);
        return false;
      }
    }

    // handle categories
    if($current_step.hasClass('selecting-item-category')){
      if($current_step.find('.os-item-category-w .os-item-category-w.selected').length){
        $current_step.find('.os-item-category-w .os-item-category-w.selected').parents('.os-item-category-w').addClass('selected').find('.os-item-category-w.selected').removeClass('selected');
      }else{
        $current_step.removeClass('selecting-item-category').find('.os-item-category-w.selected').removeClass('selected');
        $current_step.removeClass('selecting-item-category').find('.os-item-categories-holder.show-selected-only').removeClass('show-selected-only');
      }
      if(($booking_form_element.find('.reservo-step-content').length <= 1) && !$current_step.hasClass('selecting-item-category')){
        reservo_hide_prev_btn($booking_form_element);
      }
      reservo_reload_summary($booking_form_element);
      return false;
    }

    var $current_active_step = $booking_form_element.find('.reservo-step-content:last-child');
    if($current_active_step.data('clear-action')){
      window[$current_active_step.data('clear-action')]($booking_form_element);
    }

    var $back_btn = jQuery(this);
    $back_btn.addClass('os-loading');
    $booking_form_element.removeClass('step-content-loaded').addClass('step-content-loading');
    var $new_current_step = $booking_form_element.find('.reservo-step-content.is-hidden').last();
    var new_current_step_name = $new_current_step.data('step-name');
    reservo_change_step_desc($booking_form_element, new_current_step_name);
    setTimeout(function(){
      $new_current_step.removeClass('is-hidden');
      $current_active_step.remove();
      $booking_form_element.find('.reservo_current_step').val(new_current_step_name);
      $booking_form_element.removeClass(function (index, className) { return (className.match (/(^|\s)current-step-\S+/g) || []).join(' '); }).addClass('current-step-' + new_current_step_name);
      $booking_form_element.find('.reservo-next-btn span').text($booking_form_element.find('.reservo-next-btn').data('label'));
      $booking_form_element.data('next-submit-is-last', 'no');
      reservo_show_next_btn($booking_form_element);
      $back_btn.removeClass('os-loading');
      if($booking_form_element.find('.reservo-step-content').length <= 1){
        if($new_current_step.hasClass('selecting-item-category')){

        }
        if(new_current_step_name == 'services'){
          var $services_step = $booking_form_element.find('.step-services-w');
          if($services_step.hasClass('selecting-service-duration') || $services_step.hasClass('selecting-total-attendies') || $services_step.hasClass('selecting-item-category')){
            if($services_step.find('.os-services > .os-item.selected').hasClass('is-preselected')){
              // if service is preselected check if there are both multiple durations and quantity selector and only then show prev button
              if($services_step.hasClass('selecting-total-attendies') && $services_step.find('.os-services > .os-item.selected').hasClass('has-multiple-durations')){
                // if selecting attendies and there are multiple durations - show prev button
                reservo_show_prev_btn($booking_form_element);
              }else{
                reservo_hide_prev_btn($booking_form_element);
              }
            }else{
              reservo_show_prev_btn($booking_form_element);
            }
          }else{
            reservo_hide_prev_btn($booking_form_element);
          }
        }else{
          if(!$new_current_step.hasClass('selecting-item-category')){
            reservo_hide_prev_btn($booking_form_element);
          }
        }
      }
      $booking_form_element.removeClass('step-content-loading').addClass('step-content-mid-loading');
      setTimeout(function(){
        $booking_form_element.removeClass('step-content-mid-loading').addClass('step-content-loaded');
        reservo_hide_message_inside_element($booking_form_element.find('.reservo-body'));
        reservo_reload_summary($booking_form_element);
      }, 150);
    }, 700);
    return false;
  });
}

function reservo_init_booking_form_by_trigger($trigger){
    var route = reservo_helper.booking_button_route;
    var params = {};
    var restrictions = {};
    if($trigger.data('show-service-categories')) restrictions.show_service_categories = $trigger.data('show-service-categories');
    if($trigger.data('show-locations')) restrictions.show_locations = $trigger.data('show-locations');
    if($trigger.data('show-services')) restrictions.show_services = $trigger.data('show-services');
    if($trigger.data('show-agents')) restrictions.show_agents = $trigger.data('show-agents');
    if($trigger.data('selected-location')) restrictions.selected_location = $trigger.data('selected-location');
    if($trigger.data('selected-agent')) restrictions.selected_agent = $trigger.data('selected-agent');
    if($trigger.data('selected-service')) restrictions.selected_service = $trigger.data('selected-service');
    if($trigger.data('selected-duration')) restrictions.selected_duration = $trigger.data('selected-duration');
    if($trigger.data('selected-total-attendees')) restrictions.selected_total_attendies = $trigger.data('selected-total-attendees');
    if($trigger.data('selected-service-category')) restrictions.selected_service_category = $trigger.data('selected-service-category');
    if($trigger.data('selected-start-date')) restrictions.selected_start_date = $trigger.data('selected-start-date');
    if($trigger.data('selected-start-time')) restrictions.selected_start_time = $trigger.data('selected-start-time');
    if($trigger.data('calendar-start-date')) restrictions.calendar_start_date = $trigger.data('calendar-start-date');
    if($trigger.data('source-id')) restrictions.source_id = $trigger.data('source-id');

    if(jQuery.isEmptyObject(restrictions) == false) params.restrictions = restrictions;

    var data = { action: reservo_helper.route_action, route_name: route, params: params, layout: 'none', return_format: 'json' }
    $trigger.addClass('os-loading');
    jQuery.ajax({
      type : "post",
      dataType : "json",
      url : reservo_helper.ajaxurl,
      data : data,
      success: function(data){
        if(data.status === "success"){
          var lightbox_class = 'booking-form-in-lightbox';
          if($trigger.data('hide-summary') != 'yes') lightbox_class+= ' reservo-with-summary';
          if($trigger.data('hide-side-panel') == 'yes') lightbox_class+= ' reservo-hide-side-panel';
          reservo_show_data_in_lightbox(data.message, lightbox_class);
          var $booking_form_element = jQuery('.reservo-lightbox-w .reservo-booking-form-element');
          reservo_init_booking_form($booking_form_element);
          reservo_init_step(data.step, $booking_form_element);
          jQuery('body').addClass('reservo-lightbox-active');
          $trigger.removeClass('os-loading');

        }else{
          $trigger.removeClass('os-loading');
          // console.log(data.message);
        }
      }
    });
  }